module.exports = __webpack_public_path__ + "static/media/VirtualSeminar.e166b508.png";